var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMahnen = function SvgMahnen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 562.5h-125V218.7h125zM500 781.2c-25.3 0-48.1-15.2-57.7-38.6-9.7-23.4-4.3-50.3 13.6-68.1 17.9-17.9 44.8-23.2 68.1-13.6 23.4 9.7 38.6 32.5 38.6 57.7-.1 34.7-28.1 62.6-62.6 62.6M500 0C367.4 0 240.2 52.7 146.4 146.4 52.7 240.2 0 367.4 0 500s52.7 259.8 146.4 353.6c93.8 93.7 221 146.4 353.6 146.4s259.8-52.7 353.6-146.4c93.7-93.8 146.4-221 146.4-353.6s-52.7-259.8-146.4-353.6C759.8 52.7 632.6 0 500 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMahnen);
export default ForwardRef;